import APIService from '../api';
export default class CoinsService extends APIService {
  sendCoins(data: object) {
    return this.post('/admin/award-coin', data);
  }
}
